import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { ApiError } from "@/services/expenseApi";
import { backfillAccounts } from "@/services/accountApi";
import { useAccountStore } from "./store/useAccountStore";
import AccountForm from "./components/AccountForm";
import AccountList from "./components/AccountList";
import SuggestionCard from "./components/SuggestionCard";
import NetWorthChart from "./components/NetWorthChart";

export default function AccountsPage() {
  const loadAccounts = useAccountStore((s) => s.loadAccounts);
  const loadSuggestions = useAccountStore((s) => s.loadSuggestions);
  const suggestions = useAccountStore((s) => s.suggestions);

  useEffect(() => {
    async function load() {
      try {
        await Promise.all([loadAccounts(), loadSuggestions()]);
      } catch {
        // Empty state covers a failed load; the user can retry by revisiting.
      }
    }
    void load();
  }, [loadAccounts, loadSuggestions]);

  const [backfilling, setBackfilling] = useState(false);

  async function handleBackfill() {
    setBackfilling(true);
    try {
      const { assigned } = await backfillAccounts();
      toast.success(`${assigned} past transactions assigned`);
      await loadAccounts();
    } catch (err) {
      toast.error(err instanceof ApiError ? err.message : "Backfill failed");
    } finally {
      setBackfilling(false);
    }
  }

  return (
    <>
      <div className="mb-4 flex flex-wrap items-center justify-between gap-3">
        <h1 className="text-lg font-semibold text-foreground">Accounts</h1>
        <div className="flex gap-2">
          <Button
            variant="outline"
            size="sm"
            onClick={handleBackfill}
            loading={backfilling}
          >
            <span className="sm:hidden">Assign past</span>
            <span className="hidden sm:inline">Assign past transactions</span>
          </Button>
        </div>
      </div>
      <div className="mb-6">
        <AccountList />
      </div>
      {suggestions.length > 0 && (
        <div className="mb-6 flex flex-col gap-3">
          {suggestions.map((suggestion) => (
            <SuggestionCard key={suggestion.id} suggestion={suggestion} />
          ))}
        </div>
      )}
      <AccountForm />
      <NetWorthChart />
    </>
  );
}
